import loadable from "@loadable/component";
import { useEffect, useRef, useState } from "react";
import { AccommodationType } from "@shared/models/article";

const ArticlesCarousel = loadable(
  () => import(/* webpackChunkName: "articles-carousel" */ "./article-carousels")
    .then(({ ArticlesCarousel }) => ({ default: ArticlesCarousel })),
  { ssr: false }
);

type Props = {
  type: AccommodationType;
};

/**
 * Related property carousels are below the primary content. They are enhanced
 * on the client shortly before they enter the viewport instead of delaying the
 * initial rendering and hydration of the page.
 */
const DeferredArticlesCarousel = ({ type }: Props) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [ shouldLoad, setShouldLoad ] = useState(false);

  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(([ entry ]) => {
      if (!entry.isIntersecting) return;

      setShouldLoad(true);
      observer.disconnect();
    }, { rootMargin: "300px 0px" });

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={targetRef} className="articles-carousel-deferred">
      {shouldLoad && <ArticlesCarousel type={type} />}
    </div>
  );
};

export default DeferredArticlesCarousel;
